import { css } from "@emotion/react";
import { TextLink } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";

type Props = {
  onDismiss: () => void;
};

export const SignInErrorBanner = ({ onDismiss }: Props) => (
  <div css={banner}>
    ログインに失敗しました。ユーザーIDまたはパスワードが正しくありません。こちらから再度試し
    <br />
    てください。
    <span css={linkWrapper}>
      <TextLink onClick={onDismiss}>ログイン</TextLink>
    </span>
  </div>
);

const banner = css({
  backgroundColor: color.cherub,
  border: `1px solid ${color.mandysPink}`,
  borderRadius: "4px",
  padding: "12px 16px",
  marginBottom: "16px",
  color: color.chestnutRose,
  fontSize: "14px",
  lineHeight: "1.6",
});

const linkWrapper = css({
  marginLeft: "4px",
  cursor: "pointer",
});
